var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "index" }, [
    _c(
      "div",
      { staticClass: "main-wrapper" },
      [
        _c("layout-header"),
        _vm._v(" "),
        _c("layout-sidebar"),
        _vm._v(" "),
        _c("div", { staticClass: "page-wrapper" }, [
          _c("div", { staticClass: "content container-fluid" }, [
            _c("div", { staticClass: "page-header" }, [
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col" }, [
                  _c("h3", { staticClass: "page-title" }, [
                    _vm._v("Statistik Products")
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "breadcrumb" }, [
                    _c(
                      "li",
                      { staticClass: "breadcrumb-item" },
                      [
                        _c("router-link", { attrs: { to: "/index-agent" } }, [
                          _vm._v("Dashboard")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("li", { staticClass: "breadcrumb-item active" }, [
                      _vm._v("Statistik Products")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-auto float-right ml-auto" }, [
                  _c("div", { staticClass: "form-group form-focus" }, [
                    _c("div", { staticClass: "btn-group btn-block" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn add-btn btn-block",
                          staticStyle: { "min-width": "auto" },
                          attrs: {
                            type: "button",
                            "data-toggle": "dropdown",
                            "aria-haspopup": "true",
                            "aria-expanded": "false"
                          }
                        },
                        [
                          !_vm.isLoadingImage
                            ? _c("span", [
                                _c("i", { staticClass: "fa fa-download" }),
                                _vm._v(" Download Image")
                              ])
                            : _c("span", [_vm._v("...")])
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "dropdown-menu" }, [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            attrs: {
                              disabled: _vm.isLoadingImage,
                              href: "javascript:void(0)"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.downloadImagePNG()
                              }
                            }
                          },
                          [_vm._v("PNG")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            attrs: {
                              disabled: _vm.isLoadingImage,
                              href: "javascript:void(0)"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.downloadImageJPEG()
                              }
                            }
                          },
                          [_vm._v("JPEG")]
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "row filter-row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "form-group row" }, [
                      _c("label", { staticClass: "col-form-label col-md-4" }, [
                        _vm._v("Brand")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-8" },
                        [
                          _c(
                            "multiselect",
                            {
                              attrs: {
                                id: "ajax",
                                label: "license_name",
                                "track-by": "id",
                                placeholder: "Type to search Brand...",
                                multiple: true,
                                "open-direction": "bottom",
                                "custom-label": _vm.customLabel,
                                options: _vm.contactOptions,
                                searchable: true,
                                loading: _vm.isLoading,
                                "internal-search": false,
                                "close-on-select": false,
                                "options-limit": 300,
                                limit: 3,
                                "limit-text": _vm.limitText,
                                "max-height": 600,
                                "show-no-results": true,
                                "hide-selected": true,
                                "show-labels": false
                              },
                              on: { "search-change": _vm.asyncFind },
                              scopedSlots: _vm._u([
                                {
                                  key: "tag",
                                  fn: function(ref) {
                                    var option = ref.option
                                    var remove = ref.remove
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "custom__tag" },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(option.name))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "custom__remove",
                                              on: {
                                                click: function($event) {
                                                  return remove(option)
                                                }
                                              }
                                            },
                                            [_vm._v("❌")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "clear",
                                  fn: function(props) {
                                    return [
                                      _vm.selectedContact.length
                                        ? _c("div", {
                                            staticClass: "multiselect__clear",
                                            on: {
                                              mousedown: function($event) {
                                                $event.preventDefault()
                                                $event.stopPropagation()
                                                return _vm.clearAll(
                                                  props.search
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.selectedContact,
                                callback: function($$v) {
                                  _vm.selectedContact = $$v
                                },
                                expression: "selectedContact"
                              }
                            },
                            [
                              _vm._v(" "),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  attrs: { slot: "noResult" },
                                  slot: "noResult"
                                },
                                [_vm._v("Oops! No elements found.")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "form-group row" }, [
                      _c("label", { staticClass: "col-form-label col-md-4" }, [
                        _vm._v("Product")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-8" },
                        [
                          _vm.selectedContact.length
                            ? _c(
                                "multiselect",
                                {
                                  attrs: {
                                    id: "ajax",
                                    label: "name",
                                    "track-by": "id",
                                    placeholder: "Type to search Product...",
                                    multiple: true,
                                    "open-direction": "bottom",
                                    "custom-label": _vm.customLabel,
                                    options: _vm.productOptions,
                                    searchable: true,
                                    loading: _vm.isLoading,
                                    "internal-search": false,
                                    "close-on-select": false,
                                    "options-limit": 300,
                                    limit: 3,
                                    "limit-text": _vm.limitText,
                                    "max-height": 600,
                                    "show-no-results": true,
                                    "hide-selected": true,
                                    "show-labels": false
                                  },
                                  on: { "search-change": _vm.asyncFindProduct },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "tag",
                                        fn: function(ref) {
                                          var option = ref.option
                                          var remove = ref.remove
                                          return [
                                            _c(
                                              "span",
                                              { staticClass: "custom__tag" },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(option.name))
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "custom__remove",
                                                    on: {
                                                      click: function($event) {
                                                        return remove(option)
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("❌")]
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "clear",
                                        fn: function(props) {
                                          return [
                                            _vm.selectedProduct.length
                                              ? _c("div", {
                                                  staticClass:
                                                    "multiselect__clear",
                                                  on: {
                                                    mousedown: function(
                                                      $event
                                                    ) {
                                                      $event.preventDefault()
                                                      $event.stopPropagation()
                                                      return _vm.clearAll(
                                                        props.search
                                                      )
                                                    }
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1857285805
                                  ),
                                  model: {
                                    value: _vm.selectedProduct,
                                    callback: function($$v) {
                                      _vm.selectedProduct = $$v
                                    },
                                    expression: "selectedProduct"
                                  }
                                },
                                [
                                  _vm._v(" "),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "noResult" },
                                      slot: "noResult"
                                    },
                                    [_vm._v("Oops! No elements found.")]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row filter-row" }, [
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group form-focus" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.columnFilters.start_date,
                            expression: "columnFilters.start_date"
                          }
                        ],
                        staticClass: "form-control floating",
                        attrs: { type: "date" },
                        domProps: { value: _vm.columnFilters.start_date },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.columnFilters,
                              "start_date",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "focus-label sr-only" }, [
                        _vm._v("From")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group form-focus" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.columnFilters.end_date,
                            expression: "columnFilters.end_date"
                          }
                        ],
                        staticClass: "form-control floating",
                        attrs: { type: "date" },
                        domProps: { value: _vm.columnFilters.end_date },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.columnFilters,
                              "end_date",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "focus-label sr-only" }, [
                        _vm._v("To")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group form-focus" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-success btn-block",
                          attrs: {
                            href: "javascript:void(0)",
                            id: "searchData"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.searchData($event)
                            }
                          }
                        },
                        [_vm._v("Search")]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group form-focus" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-secondary btn-block",
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.clearData($event)
                            }
                          }
                        },
                        [_vm._v("Clear")]
                      )
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.isCheckBrandProduct
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _vm._v(
                      "\n          Silakan pilih Brand dan Produk untuk melihat laporan.\n        "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isCheckBrandProduct == false,
                    expression: "isCheckBrandProduct == false"
                  }
                ]
              },
              [
                _vm.isLoadingData
                  ? [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [_c("Skeleton", { attrs: { count: 1 } })],
                          1
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "downloadImage",
                    style: _vm.isLoadingData
                      ? "visibility: hidden;"
                      : "visibility: visible"
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-12" },
                        [
                          _vm.cloudData.length > 0
                            ? _c("TotalKeywords", {
                                attrs: { propCloudData: _vm.cloudData }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "card card__custom-height" }, [
                          _c(
                            "div",
                            { staticClass: "card-body " },
                            [
                              _c("TotalScrapeMarketplace", {
                                attrs: {
                                  propSeries: _vm.series1,
                                  propChartLabel: _vm.chartLabel1
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "card card__custom-height" }, [
                          _c(
                            "div",
                            { staticClass: "card-body " },
                            [
                              _c("apexchart", {
                                ref: "barchart",
                                attrs: {
                                  options: _vm.chartOptions2,
                                  series: _vm.series2,
                                  type: "bar"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "card" }, [
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("TotalStatusPerMP", {
                                attrs: {
                                  propSeries3: _vm.seriesShopee,
                                  mpId: "shopee"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "card" }, [
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("TotalStatusPerMP", {
                                attrs: {
                                  propSeries3: _vm.seriesTokopedia,
                                  mpId: "tokopedia"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "card" }, [
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("TotalStatusPerMP", {
                                attrs: {
                                  propSeries3: _vm.seriesLazada,
                                  mpId: "lazada"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "card" }, [
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("TotalStatusPerMP", {
                                attrs: {
                                  propSeries3: _vm.seriesBukalapak,
                                  mpId: "bukalapak"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  ]
                )
              ],
              2
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn add-btn dropdown-toggle dropdown-toggle-split",
        staticStyle: { "min-width": "auto" },
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Toggle Dropdown")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f15cf59", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f15cf59","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/monitoring/summary/indexAgent.vue
// module id = null
// module chunks = 